/* Tasslugn – gåvor i varukorgen. Gåvorna (0 kr) läggs till automatiskt när kunden har
   tillräckligt många av en produkt som ger gåvan (även när antalet höjs med plus-knappen
   i varukorgen), och tas bort när antalet sänks under gränsen. Max 1 st av varje gåva.
   Måltidsstationen: badborste vid 2+, tuggben vid 3+.
   Jaktkompisen: bajspåshållare vid 2+, bajspåshållare + tuggben vid 3+. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const RULES = [
  { handle: 'badborste-silikon-gava', from: { 'tasslugn-maltidsstation': 2 } },
  { handle: 'tuggben-med-rep-gava', from: { 'tasslugn-maltidsstation': 3, jaktkompisen: 3 } },
  { handle: 'bajspashallare-gava', from: { jaktkompisen: 2 } },
];
const variantIds = {};
let busy = false;
let again = false;

async function giftVariant(handle) {
  if (handle in variantIds) return variantIds[handle];
  try {
    const p = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then((r) => {
      if (!r.ok) throw 0;
      return r.json();
    });
    const v = p.variants.find((x) => x.available) || null;
    variantIds[handle] = v ? v.id : null;
  } catch (e) {
    variantIds[handle] = null;
  }
  return variantIds[handle];
}

async function check() {
  if (busy) {
    again = true;
    return;
  }
  busy = true;
  again = false;
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const count = (h) => cart.items.filter((i) => i.handle === h).reduce((s, i) => s + i.quantity, 0);
    const updates = {};
    for (const rule of RULES) {
      const allowed = Object.keys(rule.from).some((h) => count(h) >= rule.from[h]) ? 1 : 0;
      const lines = cart.items.filter((i) => i.handle === rule.handle);
      let left = allowed;
      for (const line of lines) {
        const q = Math.min(line.quantity, left);
        left -= q;
        if (q !== line.quantity) updates[line.key] = q;
      }
      if (allowed && !lines.length) {
        const id = await giftVariant(rule.handle);
        if (id) updates[id] = 1;
      }
    }
    const keys = Object.keys(updates);
    if (!keys.length) return;
    const sections = Array.from(document.querySelectorAll('cart-items-component'))
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'cart',
        lines: keys.map((k) => ({ id: k, quantity: updates[k] })),
        promise: deferred.promise,
      })
    );
    const data = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sections.join(','), sections_url: window.location.pathname }),
    }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
      detail: { items: data.items, sections: data.sections, source: 'tasslugn-gava', didError: false },
    });
  } catch (e) {
    /* tyst – försök igen vid nästa ändring */
  } finally {
    setTimeout(() => {
      busy = false;
      if (again) check();
    }, 300);
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.detail && event.detail.source === 'tasslugn-gava') return;
  const p = event.promise || Promise.resolve();
  p.then(() => setTimeout(check, 80)).catch(() => {});
});
check();
